module.exports = __webpack_public_path__ + "img/germany.6b10db3c.svg";